import { render } from "./OthelloBoard.vue?vue&type=template&id=770cc177&scoped=true"
import script from "./OthelloBoard.vue?vue&type=script&lang=js"
export * from "./OthelloBoard.vue?vue&type=script&lang=js"

import "./OthelloBoard.vue?vue&type=style&index=0&id=770cc177&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-770cc177"]])

export default __exports__